import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id F88B9364-AE49-4AF6-A891-E20068064832
 * name arrow-left-bold-outline
 * version: 2.5.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/arrow-left-bold-outline.svg
 * tags
 * - Arrow 
 * - Automotive 
 */
export const ArrowLeftBoldOutlineIcon = createSvgIcon(<><path d="M13,22L3,12L13,2V8H21V16H13V22M6,12L11,17V14H19V10H11V7L6,12Z" /></>, 'ArrowLeftBoldOutlineIcon');
export default ArrowLeftBoldOutlineIcon